import * as PIXI from 'pixi.js'
import config from 'config'
import {
  getSpineList, getReplacedSpineData, getSpinesFromStage,
  setSpineHash, updateSpinePages, replaceSpineBase,
  storeReplacedSpine, convertUrlToBase64, McSpine
} from '../../utils'
import SpineSelector from './SpineSelector'
import ActiveSpineEditor from './activeSpineEditor'
import SpineDummyCreator from './spineDummyCreator'

let spineBase
let spineLoader
try {
  spineBase = require('@pixi-spine/base')
  spineLoader = require('@pixi-spine/loader-uni')
} catch (e) { }

require('./spinetools.less')

class Animations extends React.Component {
  state = {}
  componentWillMount() {
    this.updateSpineList()
  }

  onReaderLoad = (event) => {
    const obj = JSON.parse(event.target.result)

    Object.keys(obj).forEach(spineName => {
      this.replaceSpines(obj[spineName], spineName)
    })

    setTimeout(() => this.forceUpdate(), 500)
  }

  updateSpineList = () => {
    const assets = getSpineList()
    this.setState({ spineEntries: Object.entries(assets) })
  }

  download = () => {
    const spines = getReplacedSpineData()
    const blob = new Blob([ JSON.stringify(spines) ], { type: 'application/json' }) // pass a useful mime type here
    const url = URL.createObjectURL(blob)

    const { downloadElement } = this
    downloadElement.setAttribute('href', url)
    downloadElement.setAttribute('download', config.GAME_CONFIG.GAME_ID + '-spines.json')
    downloadElement.click()
  }

  upload = (e) => {
    const reader = new FileReader()
    reader.onload = this.onReaderLoad
    reader.readAsText(e.target.files[0])
  }

  replaceSpines = (spineInfo, textureName) => {
    if (!spineLoader || !spineBase) {
      alert('Spine replacement only possible on projects that uses latest spine!')
      
      return
    }
    const spineName = textureName// textureName.split('_')[0]
    const { spineData, spineAtlas } = this.createNewSpineData(spineInfo, spineName)

    // Get and replace existing spines
    const existingSpines = getSpinesFromStage(spineName)
    const keysToIgnore = [
      'parent',
      'transform',
    ]

    if (existingSpines) {
      existingSpines.forEach(s => {
        const hasPrevious = s.state.tracks.length > 0
        let previousAnim
        const previousVisibility = s.visible
        if (hasPrevious) {
          previousAnim = {
            loop: s.state.tracks[0] && s.state.tracks[0].loop,
            name: s.state.tracks[0] && s.state.tracks[0].animation.name
          }
        }

        const tempSpine = new McSpine(spineData)
        Object.keys(tempSpine).forEach(key => {
          if (keysToIgnore.indexOf(key) === -1) {
            s[key] = tempSpine[key]
          }
        })

        s.visible = previousVisibility
        if (previousAnim && s.spineData.animations.find(a => a.name === previousAnim.name)) {
          s.state.setAnimation(0, previousAnim.name, previousAnim.loop)
        } else {
          s.state.setAnimation(0, s.spineData.animations[0].name, false)
        }
      })
    }

    setSpineHash(spineName, spineData.hash)

    updateSpinePages({ spineAtlas, spineName })

    spineInfo.images.forEach((ci, i) => {
      const img = new Image()
      img.onload = () => {
        const baseImg = new PIXI.BaseTexture(img)
        replaceSpineBase({
          spineName, imgName: ci.name, index: i, texture: baseImg
        })
        this.forceUpdate()
      }

      img.src = ci.src
    })

    storeReplacedSpine(spineName, spineInfo)
  }

  createNewSpineData = (output, name) => {
    const { atlas, json, images } = output
    const rawAtlasData = convertUrlToBase64(atlas)
    const rawSkeletonData = convertUrlToBase64(json)

    PIXI.Loader.shared.resources[`${name}_atlas`].data = rawAtlasData

    const spineAtlas = new spineBase.TextureAtlas(rawAtlasData, (line, callback) => {
      const img = new Image()
      img.src = images.find(i => i.name === line).src
      callback(new PIXI.BaseTexture(img))
    })

    const SpineParser = new spineLoader.SpineParser()

    const ret = {}

    const parsedData = JSON.parse(rawSkeletonData)

    SpineParser.parseData(ret, SpineParser.createJsonParser(), spineAtlas, parsedData)

    const res = PIXI.Loader.shared.resources[name]
    res.spineData = ret.spineData
    res.spineAtlas = ret.spineAtlas
    res.data = parsedData

    return ret
  }

  render() {
    const { spineEntries = [] } = this.state

    return (
      <div id="AnimationTools">
        <div className="category">Dummy creator</div>
        <SpineDummyCreator entries={spineEntries} />
        <div className="category">Active spines</div>
        <ActiveSpineEditor />
        <div className="category">Spine assets</div>
        <a ref={e => this.downloadElement = e} style={{ display: 'none' }} />
        <div style={{ textAlign: 'center', paddingBottom: '30px' }}>
          <input style={{ marginRight: '15px' }} type="button" value="Download" onClick={this.download} />
          <input type="file" id="selectFiles" onChange={this.upload} />
        </div>
        <div className="devConsolePage">
          { spineEntries.map((entry) =>
            (<SpineSelector
              textures={entry[1]}
              textureName={entry[0]}
              onReplacement={this.updateSpineList}
              key={`${entry[0]}-baseSpine`}
              replaceSpines={this.replaceSpines}
            />))
          }
        </div>
      </div>
    )
  }
}

Animations.title = 'Animations'

export default Animations
